"use client";

import SmallImagesNewsCard from "../Helper/SmallImagesNewsCard";
import Title from "../Helper/Title";
import Breadcrumb from "../Posts/PostDetails/Breadcrumb";
import CategoryList from "./CategoryList";
import dynamic from "next/dynamic";
const Pagination = dynamic(() => import("antd/es/pagination"), {
  ssr: false,
});
import { useRouter } from "next/navigation";
import parse from "html-react-parser";

import { usePathname } from "next/navigation";
import { Search } from "lucide-react";
import { MobileAdUnit, SidebarAd } from "../AdsBox/AdsBox";
import { useIsMobile } from "@/app/Hooks/useIsMobile";
import { buildPaginationUrl } from "@/app/lib/buildPaginationUrl";
const Category = ({
  categorySlug,
  categoryData,
  breadCrumbAndTitle,
  meta,
  currentPage = 1,
  viralNews,
}) => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const pathname = usePathname();

  const handlePageChange = (page) => {
    const url = buildPaginationUrl(pathname, page);

    router.push(url);
  };

  const breadcrumbs =
    pathname === "/search"
      ? [
          {
            label: "Home",
            url: "/",
          },
          {
            label: categorySlug
              ? `Search Results for "${categorySlug}"`
              : "Search",
            url: `/search?s=${categorySlug || ""}`,
          },
        ]
      : [
          ...(breadCrumbAndTitle?.breadcrumb || []),
          ...(currentPage > 1
            ? [
                {
                  label: `Page ${currentPage}`,
                  url: "",
                },
              ]
            : []),
        ];

  const design = (
    <>
      <div className=" mt-3">
        <Breadcrumb breadcrumbs={breadcrumbs} />

        {pathname === "/search" ? (
          <div className="max-w-3xl bg-white">
            <h1 className="text-md font-extrabold text-black mb-4">
              {categorySlug}
            </h1>

            <div className="relative">
              <input
                type="text"
                defaultValue={categorySlug}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && e.target.value.trim()) {
                    router.push(
                      `/search?s=${encodeURIComponent(e.target.value)}`,
                    );
                  }
                }}
                placeholder="Search..."
                className="w-full bg-gray-100 px-5 py-2 pr-14 text-lg outline-none"
              />

              <button
                onClick={(e) => {
                  const value = e.currentTarget.previousSibling.value;
                  if (value.trim()) {
                    router.push(`/search?s=${encodeURIComponent(value)}`);
                  }
                }}
                className="absolute right-4 top-1/2 -translate-y-1/2"
              >
                <Search className="w-4 h-4" />
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div className="max-w-3xl bg-white ">
              <h1 className="text-[22px] font-extrabold text-black leading-[22px]">
                {breadCrumbAndTitle?.title}
                {currentPage > 1 ? ` - Page ${currentPage}` : null}
              </h1>

              <p className="text-[15px] leading-[23px] mt-1.5 text-base text-black">
                {parse(breadCrumbAndTitle?.description || "")}
              </p>
            </div>
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 border-t pt-6 my-6 ">
          {/* LEFT - unchanged core UI */}
          <div className="lg:col-span-8">
            <CategoryList categoryData={categoryData} />
            <div className="flex justify-center lg:justify-start pt-5 ">
              <Pagination
                defaultCurrent={currentPage}
                total={meta?.total}
                pageSize={meta?.pageSize}
                onChange={handlePageChange}
              />
            </div>
          </div>

          {/* RIGHT - new design */}
          <div className="lg:col-span-4">
            {/* <RightSidebar /> */}
            {isMobile ? <MobileAdUnit /> : <SidebarAd />}
            <aside className="order-3 lg:order-3 lg:col-span-3  mt-4">
              {/* related news */}
              <div className="mb-5">
                <Title size="18px">वायरल खबरें</Title>
              </div>

              <div className="space-y-5">
                {viralNews?.map((item, index) => (
                  <div key={index} className="border-b pb-3">
                    <SmallImagesNewsCard
                      title="खेल"
                      subtitle={item?.title}
                      image={item?.thumbnail}
                      imageAlt={item?.thumbnail_alt}
                      showDot
                      showMainTitle
                      fontWeight="800"
                      isVideo={item?.is_video}
                      href={item.permalink}
                      subtitleProps={{
                        size: "15px",
                        lineHeight: "20px",
                        className: "cursor-pointer",
                      }}
                    />
                  </div>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
  return design;
};

export default Category;
